// broiler.batches.index — the canonical /broiler/batches hub.
//
// broiler.batches.hub owns all render data: repaired ppp-v4 rows, complete
// poultry history, and feed costs. BroilerListHub keeps BatchesContext only as
// a setter mirror so the retained App form/save closures see the same rows; it
// never reads BatchesContext.batches or AuthContext.dataLoaded. App's ppp-v4
// save helper optimistically mirrors ppp-v4 into this resource cache, then
// invalidates it after persistence settles.

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'broiler.batches.index',
  obligations: Object.freeze([Object.freeze({id: 'broiler.batches.hub', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
